/**
 * Journalisation applicative minimale.
 *
 * Point de passage unique vers la console : cela permet de couper les logs en
 * production, de préfixer uniformément, et plus tard de brancher un collecteur
 * distant sans toucher au reste du code.
 */

const PREFIX = "[jeu]";

/** En production on ne conserve que ce qui signale un problème réel. */
const debugEnabled = import.meta.env.DEV;

export const logger = {
  debug(message: string, ...args: unknown[]): void {
    if (!debugEnabled) return;
    console.log(`${PREFIX} ${message}`, ...args);
  },

  info(message: string, ...args: unknown[]): void {
    if (!debugEnabled) return;
    console.info(`${PREFIX} ${message}`, ...args);
  },

  warn(message: string, ...args: unknown[]): void {
    console.warn(`${PREFIX} ${message}`, ...args);
  },

  error(message: string, ...args: unknown[]): void {
    console.error(`${PREFIX} ${message}`, ...args);
  },
} as const;

/**
 * Normalise une valeur `catch` (de type `unknown`) en message lisible.
 */
export function describeError(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  return JSON.stringify(error);
}
